import { parseQuery, buildQuery } from '@calendly/http-tools'

const getLandingPageReferrer = () => (
  document?.referrer?.indexOf(`${document?.location?.origin}/d/`) === 0 ? document.referrer : null
)

/** URL for returning from an event-type booking page to the host’s event-type list (or landing referrer). */
export const buildProfileEventTypesListUrl = (profileSlug, search) => {
  const landingPageReferrer = getLandingPageReferrer()
  if (landingPageReferrer) {
    return landingPageReferrer
  }
  const params = parseQuery(search)
  delete params.back
  delete params.month
  delete params.date
  return `/${profileSlug}${buildQuery(params, { addQueryPrefix: true })}`
}
